import { useState } from "react"
import { Alert, Button } from "react-bootstrap"
import { DELETE_ACCOUNT_URL } from "../Api"
import "./DeleteAccount.css"
import ErrorWindow from '../Indicators/ErrorWindow'
import LoadingIndicator from "../Indicators/LoadingIndicator"
import { Redirect } from "react-router-dom/cjs/react-router-dom.min"
import { APP_DIRECTORY } from "../SystemVariables"

const DeleteAccount = (props) => {
    const [error, setError] = useState()
    const [submitting, setSubmitting] = useState()
    const [logout, setLogout] = useState()
    const onDeleteComplete = () => {
        setSubmitting(false)
        setLogout(true)
    }

    const onDeleteError = e => {
        setSubmitting(false)
        setError("Something went wrong, please try again later.")
    }

    const deleteAccount = () => {
        setSubmitting(true)
        fetch(DELETE_ACCOUNT_URL, {
            method: 'get',
            headers: {'Authorization':`Bearer ${props.accessToken}`}
        })
        .then(response=>{
            if(!response.ok) {
                const error = new Error(`Network response was not ok: ${response.status}`)
                error.response = response
                throw error
            } else {
                onDeleteComplete()
            }
        })
        .catch((err)=>{
            onDeleteError(err)
        })
    }
    if(logout) {
        return <Redirect to={`${APP_DIRECTORY}/logout`}/>
    } else if(error) {
        return <ErrorWindow message={error} continue={()=>{setError(undefined)}}/>
    } else if(submitting) {
        return <LoadingIndicator message={"Deleting your account."}/>
    } else {
        return(<div className="deleteAccount">
            <Alert variant="danger">
                Are you sure you want to delete your account? This cannot be undone.
            </Alert>
            <div className="navButtons">
                <Button variant="secondary" onClick={props.cancel}>Cancel</Button>
                <Button variant="danger" onClick={deleteAccount}>Delete now</Button>
            </div>
        </div>)
    }
}

export default DeleteAccount
